export const Social_Platform = {
    darkslateblue: '#3B5998',
    dodgerblue: '#1DA1F2',
    red: '#FF0000',
    mediumvioletred: '#C32AA3',
    venetianred: '#BD081C',
    darkbluecyan: '#007BB5',
    yellow: '#FFFC00',
    mediumseagreen: '#25D366',
    darkslategrey: '#35465D',
    orangered: '#FF4500',
    crimson: '#D32323',
    mediumgreen: '#1ED760',
    indianred: '#F94877',
    goldenrod: '#FFA633',
    darkgreencyan: '#02B875',
    summersky: '#1AB7EA',
    rust: '#AA2200',
    indigo: '#4A154B',
    blueviolet: '#9146FF',
    deepskyblue: '#00AFF0'
};
export const Material_Design_Red = {
    lavenderblush: '#FFEBEE',
    pink: '#FFCDD2',
    darksalmon: '#EF9A9A',
    lightcoral: '#E57373',
    sunsetorange: '#EF5350',
    tomato: '#F44336',
    cinnabar: '#E53935',
    crimson: '#D32F2F',
    persianred: '#C62828',
    firebrick: '#B71C1C'
};
export const Material_Design_Pink = {
    mistyrose: '#FCE4EC',
    pink: '#F8BBD0',
    hotpink: '#F48FB1',
    palevioletred: '#F06292',
    indianred: '#EC407A',
    ruby: '#E91E63',
    magenta: '#D81B60',
    crimson: '#C2185B',
    brown: '#AD1457',
    purple: '#880E4F'
};
export const Material_Design_Purple = {
    lavender: '#F3E5F5',
    thistle: '#E1BEE7',
    plum: '#CE93D8',
    mediumorchid: '#BA68C8',
    deeplilac: '#AB47BC',
    darkorchid: '#9C27B0',
    vividviolet: '#8E24AA',
    darkmagenta: '#7B1FA2',
    purple: '#6A1B9A',
    indigo: '#4A148C'
};
export const Material_Design_Deep_Purple = {
    lavender: '#EDE7F6',
    thistle: '#D1C4E9',
    lightsteelblue: '#B39DDB',
    mediumpurple: '#9575CD',
    slateblue: '#7E57C2',
    purpleheart: '#673AB7',
    darkslateblue: '#5E35B1',
    daisybush: '#512DA8',
    bluegem: '#4527A0',
    indigo: '#311B92'
};
const Material_Design_Indigo = {
    lavender: '#E8EAF6',
    lightsteelblue: '#C5CAE9',
    echoblue: '#9FA8DA',
    mediumpurple: '#7986CB',
    slateblue: '#5C6BC0',
    freespeechblue: '#3F51B5',
    Ceruleanblue: '#3949AB',
    toryblue: '#303F9F',
    egyptianblue: '#283593',
    midnightblue: '#1A237E'
};
const Material_Design_Blue = {
    lavender: '#E3F2FD',
    powderblue: '#BBDEFB',
    lightskyblue: '#90CAF9',
    mayablue: '#64B5F6',
    summersky: '#42A5F5',
    dodgerblue: '#2196F3',
    cornflowerblue: '#1E88E5',
    navyblue: '#1976D2',
    denim: '#1565C0',
    darkslateblue: '#0D47A1'
};
const Material_Design_Light_Blue = {
    lightcyan: '#E1F5FE',
    paleturquoise: '#B3E5FC',
    lightskyblue: '#81D4FA',
    mediumturquoise: '#4FC3F7',
    dodgerblue: '#29B6F6',
    deepskyblue: '#03A9F4',
    pacificblue: '#039BE5',
    dodgerpacificblue: '#0288D1',
    darkcyan: '#0277BD',
    teal: '#01579B'
};
const Material_Design_Cyan = {
    lightcyan: '#E0F7FA',
    paleturquoise: '#B2EBF2',
    skyblue: '#80DEEA',
    mediumturquoise: '#4DD0E1',
    turquoise: '#26C6DA',
    darkturquoise: '#00BCD4',
    darkturq: '#00ACC1',
    darkcyan: '#0097A7',
    darkercyan: '#00838F',
    teal: '#006064'
};
const Material_Design_Teal = {
    lavender: '#E0F2F1',
    powderblue: '#B2DFDB',
    mediumaquamarine: '#80CBC4',
    cadetblue: '#4DB6AC',
    lightseagreen: '#26A69A',
    darkcyan: '#009688',
    teal: '#00897B',
    tealblue: '#00796B',
    blueteal: '#00695C',
    darkslategrey: '#004D40'
};
const Material_Design_Green = {
    honeydew: '#E8F5E9',
    lightgrey: '#C8E6C9',
    lightgreen: '#A5D6A7',
    darkseagreen: '#81C784',
    mediumseagreen: '#66BB6A',
    mediumgreen: '#4CAF50',
    seagreen: '#43A047',
    greensea: '#388E3C',
    forestgreen: '#2E7D32',
    darkgreen: '#1B5E20'
};
const Material_Design_Light_Green = {
    honeydew: '#F1F8E9',
    gainsboro: '#DCEDC8',
    palegoldenrod: '#C5E1A5',
    darkkhaki: '#AED581',
    khakidark: '#9CCC65',
    yellowgreen: '#8BC34A',
    greenyellow: '#7CB342',
    olivedrab: '#689F38',
    drabolive: '#558B2F',
    darkolivegreen: '#33691E'
};
export const Material_Design_Lime = {
    olive: '#827717',
    darkgoldenrod: '#9E9D24',
    greeneryellow: '#AFB42B',
    yellowgreen: '#C0CA33',
    greenyellow: '#CDDC39',
    darkkhaki: '#D4E157',
    khaki: '#DCE775',
    palegoldenrod: '#E6EE9C',
    lemonchiffon: '#F0F4C3',
    honeydew: '#F1F8E9',  
};
const Material_Design_Yellow = {
    lightyellow: '#FFFDE7',
    lemonchiffon: '#FFF9C4',
    palegoldenrod: '#FFF59D',
    khaki: '#FFF176',
    huekhaki: '#FFEE58',
    gold: '#FFEB3B',
    huegold: '#FDD835',
    goldenrod: '#FBC02D',
    rodgolden: '#F9A825',
    darkorange: '#F57F17'
};
const Material_Design_Amber = {
    cornsilk: '#FFF8E1',
    moccasin: '#FFECB3',
    khaki: '#FFE082',
    sandybrown: '#FFD54F',
    gold: '#FFCA28',
    golden: '#FFC107',
    orange: '#FFB300',
    orangey: '#FFA000',
    darkorange: '#FF8F00',
    orangedark: '#FF6F00'
};
const Material_Design_Orange = {
    cornsilk: '#FFF3E0',
    moccasin: '#FFE0B2',
    khaki: '#FFCC80',
    sandybrown: '#FFB74D',
    goldenrod: '#FFA726',
    darkorange: '#FF9800',
    darkorangey: '#FB8C00',
    orangedark: '#F57C00',
    orangeydark: '#EF6C00',
    orangered: '#E65100'
};
const Material_Design_Deep_Orange = {
    linen: '#FBE9E7',
    peachpuff: '#FFCCBC',
    lightsalmon: '#FFAB91',
    salmon: '#FF8A65',
    tomato: '#FF7043',
    orangered: '#FF5722',
    redorange: '#F4511E',
    orangeyred: '#E64A19',
    chocolate: '#D84315',
    firebrick: '#BF360C'
};
const Material_Design_Brown = {
    linen: '#EFEBE9',
    lightgrey: '#D7CCC8',
    darkgrey: '#BCAAA4',
    rosybrown: '#A1887F',
    grey: '#8D6E63',
    dimgrey: '#795548',
    darkolivegreen: '#6D4C41',
    olivedarkgreen: '#5D4037',
    darkslategrey: '#4E342E',
    greydarkslate: '#3E2723'
};
const Material_Design_Grey = {
    snow: '#FAFAFA',
    whitesmoke: '#F5F5F5',
    smokewhite: '#EEEEEE',
    gainsboro: '#E0E0E0',
    silver: '#BDBDBD',
    darkgrey: '#9E9E9E',
    grey: '#757575',
    dimgrey: '#616161',
    darkslategrey: '#424242',
    black: '#212121'
};
const Material_Design_Blue_Grey = {
    whitesmoke: '#ECEFF1',
    lightgrey: '#CFD8DC',
    silver: '#B0BEC5',
    darkgrey: '#90A4AE',
    lightslategrey: '#78909C',
    slategrey: '#607D8B',
    dimgrey: '#546E7A',
    darkslategrey: '#455A64',
    darkgreyslate: '#37474F',
    greydarkslate: '#263238'
};
const Material_Design_Black_and_White = {
    black: '#000000',
    white: '#FFFFFF'
};
const Material_Design_A100 = {
    salmon: '#FF8A80',
    hotpink: '#FF80AB',
    violet: '#EA80FC',
    mediumpurple: '#B388FF',
    cornflowerblue: '#8C9EFF',
    lightskyblue: '#82B1FF',
    skylightblue: '#80D8FF',
    aquamarine: '#84FFFF',
    paleturquoise: '#A7FFEB',
    powderblue: '#B9F6CA',
    khaki: '#CCFF90',
    huekhaki: '#F4FF81',
    khakihue: '#FFFF8D',
    colorkhaki: '#FFE57F',
    khakicolor: '#FFD180',
    lightsalmon: '#FF9E80'
};
const Material_Design_A200 = {
    tomato: '#FF5252',
    deeppink: '#FF4081',
    mediumorchid: '#E040FB',
    mediumslateblue: '#7C4DFF',
    royalblue: '#536DFE',
    cornflowerblue: '#448AFF',
    mediumturquoise: '#40C4FF',
    cyan: '#18FFFF',
    aquamarine: '#64FFDA',
    mediumaquamarine: '#69F0AE',
    greenyellow: '#B2FF59',
    yellow: '#EEFF41',
    yellower: '#FFFF00',
    sandybrown: '#FFD740',
    brownsand: '#FFAB40',
    tomata: '#FF6E40'
};
const Material_Design_A400 = {
    crimson: '#FF1744',
    ruby: '#F50057',
    magenta: '#D500F9',
    blueviolet: '#651FFF',
    royalblue: '#3D5AFE',
    dodgerblue: '#2979FF',
    deepskyblue: '#00B0FF',
    cyan: '#00E5FF',
    mediumspringgreen: '#1DE9B6',
    springgreen: '#00E676',
    lawngreen: '#76FF03',
    greenyellow: '#C6FF00',
    gold: '#FFEA00',
    golden: '#FFC400',
    darkorange: '#FF9100',
    orangered: '#FF3D00'
};
const Material_Design_A700 = {
    red: '#D50000',
    mediumvioletred: '#C51162',
    darkviolet: '#AA00FF',
    violetdark: '#6200EA',
    royalblue: '#304FFE',
    navyblue: '#2962FF',
    dodgerblue: '#0091EA',
    darkturquoise: '#00B8D4',
    lightseagreen: '#00BFA5',
    limegreen: '#00C853',
    lawngreen: '#64DD17',
    chartreuse: '#AEEA00',
    gold: '#FFD600',
    orange: '#FFAB00',
    darkorange: '#FF6D00',
    orangered: '#DD2C00'
};
const Material_Design_Red_Seq = {
    lavenderblush: '#FFEBEE',
    pink: '#FFCDD2',
    darksalmon: '#EF9A9A',
    lightcoral: '#E57373',
    tomato: '#EF5350',
    tomata: '#F44336',
    crimson: '#E53935',
    crimsonred: '#D32F2F',
    firebrick: '#C62828',
    firebrickred: '#B71C1C'
};
const Material_Design_Pink_Seq = {
    mistyrose: '#FCE4EC',
    pink: '#F8BBD0',
    hotpink: '#F48FB1',
    palevioletred: '#F06292',
    indianred: '#EC407A',
    crimson: '#E91E63',
    crimsonred: '#D81B60',
    redcrimson: '#C2185B',
    brown: '#AD1457',
    purple: '#880E4F'
};
const Material_Design_Purple_Seq = {
    lavender: '#F3E5F5',
    thistle: '#E1BEE7',
    plum: '#CE93D8',
    mediumorchid: '#BA68C8',
    orchidmedium: '#AB47BC',
    darkorchid: '#9C27B0',
    orchiddark: '#8E24AA',
    darkmagenta: '#7B1FA2',
    purple: '#6A1B9A',
    indigo: '#4A148C'
};
export const Material_Design_Deep_Purple_Seq = {
    lavender: '#EDE7F6',
    thistle: '#D1C4E9',
    lightsteelblue: '#B39DDB',
    mediumpurple: '#9575CD',
    slateblue: '#7E57C2',
    blueslate: '#673AB7',
    darkslateblue: '#5E35B1',
    slatedarkblue: '#512DA8',
    darkblueslate: '#4527A0',
    indigo: '#311B92'
};
const Material_Design_Indigo_Seq = {
    lavender: '#E8EAF6',
    lightsteelblue: '#C5CAE9',
    lightsteel: '#9FA8DA',
    mediumpurple: '#7986CB',
    slateblue: '#5C6BC0',
    darkslateblue: '#3F51B5',
    darkslate: '#3949AB',
    darkblueslate: '#303F9F',
    bluedarkslate: '#283593',
    midnightblue: '#1A237E'
};
const Material_Design_Blue_Seq = {
    lavender: '#E3F2FD',
    powderblue: '#BBDEFB',
    lightskyblue: '#90CAF9',
    cornflowerblue: '#64B5F6',
    cornblue: '#42A5F5',
    dodgerblue: '#2196F3',
    dodgeblue: '#1E88E5',
    royalblue: '#1976D2',
    navyblue: '#1565C0',
    darkslateblue: '#0D47A1'
};
const Material_Design_Light_Blue_Seq = {
    lightcyan: '#E1F5FE',
    paleturquoise: '#B3E5FC',
    lightskyblue: '#81D4FA',
    mediumturquoise: '#4FC3F7',
    dodgerblue: '#29B6F6',
    deepskyblue: '#03A9F4',
    dodgeblue: '#039BE5',
    dodblue: '#0288D1',
    darkcyan: '#0277BD',
    teal: '#01579B'
};
const Material_Design_Cyan_Seq = {
    lightcyan: '#E0F7FA',
    paleturquoise: '#B2EBF2',
    skyblue: '#80DEEA',
    mediumturquoise: '#4DD0E1',
    turquoise: '#26C6DA',
    darkturquoise: '#00BCD4',
    turquoisedark: '#00ACC1',
    darkcyan: '#0097A7',
    darkercyan: '#00838F',
    teal: '#006064'
};
const Material_Design_Teal_Seq = {
    lavender: '#E0F2F1',
    powderblue: '#B2DFDB',
    mediumaquamarine: '#80CBC4',
    cadetblue: '#4DB6AC',
    lightseagreen: '#26A69A',
    darkcyan: '#009688',
    teal: '#00897B',
    tealgreen: '#00796B',
    tealblue: '#00695C',
    darkslategrey: '#004D40'
};
const Material_Design_Green_Seq = {
    honeydew: '#E8F5E9',
    lightgrey: '#C8E6C9',
    lightgreen: '#A5D6A7',
    darkseagreen: '#81C784',
    mediumseagreen: '#66BB6A',
    mediumgreen: '#4CAF50',
    seagreen: '#43A047',
    greensea: '#388E3C',
    forestgreen: '#2E7D32',
    darkgreen: '#1B5E20'
};
const Material_Design_Light_Green_Seq = {
    honeydew: '#F1F8E9',
    gainsboro: '#DCEDC8',
    palegoldenrod: '#C5E1A5',
    darkkhaki: '#AED581',
    khakidark: '#9CCC65',
    yellowgreen: '#8BC34A',
    greenyellow: '#7CB342',
    olivedrab: '#689F38',
    drabolive: '#558B2F',
    darkolivegreen: '#33691E'
};
const Material_Design_Lime_Seq = {
    honeydew: '#F1F8E9',
    lemonchiffon: '#F0F4C3',
    palegoldenrod: '#E6EE9C',
    khaki: '#DCE775',
    darkkhaki: '#D4E157',
    greenyellow: '#CDDC39',
    yellowgreen: '#C0CA33',
    greeneryellow: '#AFB42B',
    darkgoldenrod: '#9E9D24',
    olive: '#827717'
};
const Material_Design_Yellow_Seq = {
    lightyellow: '#FFFDE7',
    lemonchiffon: '#FFF9C4',
    palegoldenrod: '#FFF59D',
    khaki: '#FFF176',
    huekhaki: '#FFEE58',
    gold: '#FFEB3B',
    golden: '#FDD835',
    goldenrod: '#FBC02D',
    goldrod: '#F9A825',
    darkorange: '#F57F17'
};
const Material_Design_Amber_Seq = {
    cornsilk: '#FFF8E1',
    moccasin: '#FFECB3',
    khaki: '#FFE082',
    sandybrown: '#FFD54F',
    gold: '#FFCA28',
    golden: '#FFC107',
    orange: '#FFB300',
    orangey: '#FFA000',
    darkorange: '#FF8F00',
    orangedark: '#FF6F00'
};
const Material_Design_Orange_Seq = {
    cornsilk: '#FFF3E0',
    moccasin: '#FFE0B2',
    khaki: '#FFCC80',
    sandybrown: '#FFB74D',
    goldenrod: '#FFA726',
    darkorange: '#FF9800',
    darkerorange: '#FB8C00',
    orangedark: '#F57C00',
    darkorangey: '#EF6C00',
    orangered: '#E65100'
};
const Material_Design_Deep_Orange_Seq = {
    linen: '#FBE9E7',
    peachpuff: '#FFCCBC',
    lightsalmon: '#FFAB91',
    salmon: '#FF8A65',
    tomato: '#FF7043',
    orangered: '#FF5722',
    orangeyred: '#F4511E',
    redyorange: '#E64A19',
    chocolate: '#D84315',
    firebrick: '#BF360C'
};
const Material_Design_Brown_Seq = {
    linen: '#EFEBE9',
    lightgrey: '#D7CCC8',
    darkgrey: '#BCAAA4',
    rosybrown: '#A1887F',
    grey: '#8D6E63',
    dimgrey: '#795548',
    darkolivegreen: '#6D4C41',
    olivegreenred: '#5D4037',
    darkslategrey: '#4E342E',
    slategreydark: '#3E2723'
};
const Material_Design_Grey_Seq = {
    snow: '#FAFAFA',
    whitesmoke: '#F5F5F5',
    smokewhite: '#EEEEEE',
    gainsboro: '#E0E0E0',
    silver: '#BDBDBD',
    darkgrey: '#9E9E9E',
    grey: '#757575',
    dimgrey: '#616161',
    darkslategrey: '#424242',
    black: '#212121'
};
const Material_Design_Blue_Grey_Seq = {
    whitesmoke: '#ECEFF1',
    lightgrey: '#CFD8DC',
    silver: '#B0BEC5',
    darkgrey: '#90A4AE',
    lightslategrey: '#78909C',
    slategrey: '#607D8B',
    dimgrey: '#546E7A',
    darkslategrey: '#455A64',
    slatedarkgrey: '#37474F',
    slategreydark: '#263238'
};
const Metro_Colors = {
    yellowgreen: '#A4C400',
    olivedrab: '#60A917',
    green: '#008A00',
    lightseagreen: '#00ABA9',
    dodgerblue: '#1BA1E2',
    royalblue: '#0050EF',
    darkviolet: '#6A00FF',
    violetdark: '#AA00FF',
    orchid: '#F472D0',
    mediumvioletred: '#D80073',
    firebrick: '#A20025',
    red: '#E51400',
    orangered: '#FA6800',
    orange: '#F0A30A',
    gold: '#E3C800',
    sienna: '#825A2C',
    dimgrey: '#6D8764',
    slategrey: '#647687',
    greyslate: '#76608A',
    siena: '#A0522D'
};

const Classic_Red_Green_Light = {
    palegreen: '#B7E6A7',
    silver: '#C1E6B4',
    lightgrey: '#CAE6C0',
    greylight: '#D4E6CC',
    gainsboro: '#DDE6D9',
    borogains: '#E5E5E5',
    gainboro: '#ECDBDC',
    pink: '#F2D1D2',
    pinky: '#F8C7C9',
    lightpink: '#FCBDC0',
    lightpinky: '#FFB2B6'
};
const Classic_10 = {
    goldenrod: '#BCBD22',
    grey: '#7F7F7F',
    orchid: '#E377C2',
    sienna: '#8C564B',
    mediumpurple: '#9467BD',
    crimson: '#D62728',
    forestgreen: '#2CA02C',
    darkorange: '#FF7F0E',
    steelblue: '#1F77B4'
};
export const Classic_10_Medium = {
    skyblue: '#6DCCDA',
    darkkhaki: '#CDCC5D',
    darkgrey: '#A2A2A2',
    plum: '#ED97CA',
    grey: '#A8786E',
    mediumpurple: '#AD8BC9',
    tomato: '#ED665D',
    mediumseagreen: '#67BF5C',
    sandybrown: '#FF9E4A',
    cornflowerblue: '#729ECE'
};
const Classic_10_Light = {
    lightblue: '#9EDAE5',
    khaki: '#DBDB8D',
    silver: '#C7C7C7',
    pink: '#F7B6D2',
    rosybrown: '#C49C94',
    thistle: '#C5B0D5',
    lightsalmon: '#FF9896',
    lightgreen: '#98DF8A',
    lightersalmon: '#FFBB78',
    lightsteelblue: '#AEC7E8'
};
export const Classic_20 = {
    lightblue: '#9EDAE5',
    darkturquoise: '#17BECF',
    khaki: '#DBDB8D',
    goldenrod: '#BCBD22',
    silver: '#C7C7C7',
    grey: '#7F7F7F',
    pink: '#F7B6D2',
    orchid: '#E377C2',
    rosybrown: '#C49C94',
    sienna: '#8C564B',
    thistle: '#C5B0D5',
    mediumpurple: '#9467BD',
    lightsalmon: '#FF9896',
    crimson: '#D62728',
    lightgreen: '#98DF8A',
    forestgreen: '#2CA02C',
    lightersalmon: '#FFBB78',
    darkorange: '#FF7F0E',
    lightsteelblue: '#AEC7E8',
    steelblue: '#1F77B4'
};
const Classic_Gray_5 = {
    lightgrey: '#CFCFCF',
    grey: '#8F8782',
    darkslategrey: '#414451',
    darkgrey: '#A5ACAF',
    dimgrey: '#60636A'
};
const Classic_Color_Blind = {
    lightgrey: '#CFCFCF',
    lightsalmon: '#FFBC79',
    lightsteelblue: '#A2C8EC',
    grey: '#898989',
    chocolate: '#C85200',
    cornflowerblue: '#5F9ED1',
    dimgrey: '#595959',
    darkgrey: '#ABABAB',
    darkorange: '#FF800E',
    darkcyan: '#006BA4'
};
const Classic_Traffic_Light = {
    darkseagreen: '#9FCD99',
    khaki: '#FFDD71',
    salmon: '#F26C64',
    mediumseagreen: '#69B764',
    sandybrown: '#FFC156',
    crimson: '#D82526',
    seagreen: '#309343',
    goldenrod: '#DBA13A',
    firebrick: '#B10318'
};
const Classic_Purple_Gray_6 = {
    lightgrey: '#D7D5C5',
    plum: '#D098EE',
    grey: '#995688',
    greyer: '#94917B',
    orchid: '#DC5FBD',
    slateblue: '#7B66D2'
};
const Classic_Purple_Gray_12 = {
    lightgrey: '#DBD4C5',
    grey: '#8B7C6E',
    plum: '#D098EE',
    mediumpurple: '#AB6AD5',
    plumish: '#D898BA',
    greyer: '#995688',
    darkgrey: '#B4B19B',
    darkolivegreen: '#5F5A41',
    pink: '#FFC0DA',
    orchid: '#DC5FBD',
    lightsteelblue: '#A699E8',
    slateblue: '#7B66D2'
};
const Classic_Green_Orange_6 = {
    chocolate: '#B85A0D',
    seagreen: '#39737C',
    sandybrown: '#FFD94A',
    mediumturquoise: '#3CB7CC',
    darkorange: '#FF7F0F',
    greensea: '#32A251'
};
const Classic_Green_Orange_12 = {
    darkkhaki: '#CCC94D',
    olivedrab: '#82853B',
    darkseagreen: '#86B4A9',
    seagreen: '#39737C',
    sandybrown: '#FFD94A',
    chocolate: '#B85A0D',
    lightblue: '#98D9E4',
    mediumturquoise: '#3CB7CC',
    lightsalmon: '#FFB977',
    darkorange: '#FF7F0F',
    lightgreen: '#ACD98D',
    greensea: '#32A251'
};
const Classic_Blue_Red_6 = {
    burlywood: '#E9C39B',
    lightcoral: '#EA6B73',
    cornflowerblue: '#6BA3D6',
    sienna: '#AC613C',
    crimson: '#F02720',
    steelblue: '#2C69B0'
};
const Classic_Blue_Red_12 = {
    lightcoral: '#F4737A',
    firebrick: '#BD0A36',
    wheat: '#DDC9B4',
    rosybrown: '#AC8763',
    paleturquoise: '#B5DFFD',
    cornflowerblue: '#6BA3D6',
    burlywood: '#E9C39B',
    sienna: '#AC613C',
    lightpink: '#FFB6B0',
    crimson: '#F02720',
    lightsteelblue: '#B5C8E2',
    steelblue: '#2C69B0'
};
const Classic_Cyclic = {
    slateblue: '#6F63BB',
    blueslate: '#8A60B0',
    mediumorchid: '#BA43B4',
    palevioletred: '#C7519C',
    crimson: '#D63A3A',
    darkorange: '#FF7F0E',
    orange: '#FFAA0E',
    sandybrown: '#FFBF50',
    goldenrod: '#BCBD22',
    olivedrab: '#78A641',
    forestgreen: '#2CA030',
    lightseagreen: '#12A2A8',
    steelblue: '#1F83B4'
};
const Classic_Green = {
    darkgreen: '#09622A',
    forestgreen: '#1A7232',
    greenforest: '#27823B',
    seagreen: '#339444',
    mediumseagreen: '#69A761',
    darkseagreen: '#94BB83',
    silver: '#BCCFB4'
};
const Classic_Gray = {
    black: '#1E1E1E',
    darkslategrey: '#282828',
    darkerslategrey: '#333333',
    slatedarkgrey: '#3F3F3F',
    darkgreyslate: '#4B4B4B',
    dimgrey: '#585858',
    dimergrey: '#666666',
    dimishgrey: '#747474',
    grey: '#838383',
    lightslategrey: '#929292',
    darkgrey: '#A2A2A2',
    darkergrey: '#B2B2B2',
    silver: '#C3C3C3'
};
const Classic_Blue = {
    darkslategrey: '#26456E',
    teal: '#1C5998',
    steelblue: '#1C73B1',
    bluesteel: '#3A87B7',
    cornflowerblue: '#67ADD4',
    skyblue: '#7BC8E2',
    lightblue: '#B4D4DA'
};
const Classic_Red = {
    firebrick: '#9C0824',
    firebrickred: '#B10C1D',
    redfirebrick: '#C21417',
    brickfire: '#CF1719',
    crimson: '#D8392C',
    tomato: '#E35745',
    salmon: '#F57667',
    lightsalmon: '#F89A90',
    lightpink: '#EAC0BD'
};
const Classic_Orange = {
    saddlebrown: '#7B3014',
    brownsaddle: '#A33202',
    orangered: '#D74401',
    chocolate: '#F06511',
    coral: '#FD8938',
    sandybrown: '#FDAB67',
    burlywood: '#F0C294'
};
const Classic_Area_Red = {
    firebrick: '#BD1100',
    firebrickred: '#C92B14',
    chocolate: '#D43E25',
    chocolatey: '#E04E35',
    tomato: '#EA5E45',
    tomata: '#F46B55',
    salmon: '#FD7864',
    smokedsalmon: '#FE8B7A',
    lightsalmon: '#FD9C8F',
    lightpink: '#FBB3AB',
    pink: '#F5CAC7'
};
const Classic_Area_Green = {
    forestgreen: '#3C8200',
    olivedrab: '#4A8C1C',
    oliveydrab: '#569735',
    drabolive: '#60A24D',
    mediumseagreen: '#6CAE59',
    darkseagreen: '#7ABC5F',
    greendarksea: '#8AC765',
    darkgreensea: '#9AD26D',
    lightgreen: '#ACDC7A',
    khaki: '#C3E394',
    palegoldenrod: '#DBE8B4'
};
const Classic_Area_Brown = {
    sienna: '#BB5137',
    indianred: '#BB6348',
    indianared: '#BB7359',
    peru: '#C08262',
    peruvian: '#CC8F63',
    darksalmon: '#D89C63',
    sandybrown: '#E4AA63',
    brownsand: '#F0B763',
    burlywood: '#F7C577',
    navajowhite: '#F6D29C',
    bisque: '#F3E0C2'
};
const Classic_Red_Green = {
    darkgreen: '#09622A',
    forestgreen: '#1E7735',
    seagreen: '#2F8E41',
    mediumseagreen: '#69A761',
    darkseagreen: '#A2C18F',
    lightgrey: '#CACACA',
    salmon: '#FC8375',
    indianred: '#DF513F',
    firebrick: '#D11719',
    brickfire: '#BD1316',
    firebrickred: '#9C0824'
};
const Classic_Red_Blue = {
    darkslategrey: '#26456E',
    teal: '#1C5998',
    steelblue: '#1C73B1',
    bluesteel: '#3A87B7',
    cornflowerblue: '#67ADD4',
    lightgrey: '#CACACA',
    salmon: '#FC8375',
    indianred: '#DF513F',
    firebrick: '#D11719',
    brickfire: '#BD1316',
    firebrickred: '#9C0824'
};
const Classic_Red_Black = {
    black: '#1E1E1E',
    darkslategrey: '#383838',
    dimgrey: '#565656',
    grey: '#777777',
    darkgrey: '#9B9B9B',
    lightgrey: '#CACACA',
    salmon: '#FC8375',
    indianred: '#DF513F',
    firebrick: '#D11719',
    redfirebrick: '#BD1316',
    firebrickred: '#9C0824'
};
const Classic_Area_Red_Green = {
    olivedrab: '#4A8C1C',
    drabolive: '#559633',
    olivedraby: '#5EA049',
    mediumseagreen: '#69AA56',
    darkseagreen: '#75B65D',
    seadarkgreen: '#82C162',
    darkgreensea: '#90CB68',
    darkkhaki: '#A0D571',
    lightgreen: '#B1DE7F',
    khaki: '#C7E298',
    wheat: '#E9DABE',
    lightsalmon: '#FCA294',
    lightersalmon: '#FE8E7E',
    salmon: '#FD7E6B',
    coral: '#F7705B',
    tomato: '#EF654D',
    tomata: '#E6583E',
    chocolate: '#DC4930',
    firebrick: '#D23A21',
    redfirebrick: '#C82912',
    firebrickred: '#BD1100'
};
const Classic_Orange_Blue = {
    darkslategrey: '#26456E',
    teal: '#1C5998',
    steelblue: '#1C73B1',
    bluesteel: '#3A87B7',
    cornflowerblue: '#67ADD4',
    skyblue: '#7BC8E2',
    lightgrey: '#CACACA',
    sandybrown: '#FDAB67',
    coral: '#FD8938',
    chocolate: '#F06511',
    orangered: '#D74401',
    saddlebrown: '#A33202',
    brownsaddle: '#7B3014'
};
const Classic_Green_Blue = {
    darkslategrey: '#26456E',
    teal: '#1C5998',
    steelblue: '#1C73B1',
    bluesteel: '#3A87B7',
    cornflowerblue: '#67ADD4',
    lightgrey: '#CACACA',
    darkseagreen: '#A2C18F',
    mediumseagreen: '#69A761',
    seagreen: '#2F8E41',
    forestgreen: '#1E7735',
    darkgreen: '#09622A'
};
const Classic_Red_White_Green = {
    darkgreen: '#09622A',
    forestgreen: '#297839',
    seagreen: '#428F49',
    darkseagreen: '#74AF72',
    silver: '#B9D7B7',
    white: '#FFFFFF',
    lightpink: '#FCB4A5',
    tomato: '#E86753',
    firebrick: '#CC312B',
    firebrickred: '#B41F27',
    redfirebrick: '#9C0824'
};
const Classic_Red_White_Black = {
    black: '#1E1E1E',
    darkslategrey: '#393939',
    dimgrey: '#575757',
    grey: '#838383',
    silver: '#BFBFBF',
    white: '#FFFFFF',
    lightpink: '#FCB4A5',
    tomato: '#E86753',
    firebrick: '#CC312B',
    redfirebrick: '#B41F27',
    firebrickred: '#9C0824'
};
const Classic_Orange_White_Blue = {
    darkslategrey: '#26456E',
    darkslateblue: '#2E5F8A',
    steelblue: '#3679A8',
    cadetblue: '#6A9EC5',
    lightsteelblue: '#B7CDE2',
    white: '#FFFFFF',
    navajowhite: '#FFC2A1',
    coral: '#FB8547',
    chocolate: '#D85A13',
    sienna: '#A84415',
    saddlebrown: '#7B3014'
};
const Classic_Red_White_Black_Light = {
    silver: '#C6C6C6',
    lightgrey: '#D1D1D1',
    gainsboro: '#DDDDDD',
    lavender: '#E8E8E8',
    whitesmoke: '#F3F3F3',
    white: '#FFFFFF',
    lavenderblush: '#FFF0F0',
    mistyrose: '#FFE0E1',
    pink: '#FFD1D3',
    pinker: '#FFC2C5'
};
const Classic_Orange_White_Blue_Light = {
    powderblue: '#C4D8F3',
    lavender: '#D0E0F6',
    purplelavender: '#DCE8F8',
    lavenderblue: '#E8EFFA',
    aliceblue: '#F3F7FD',
    white: '#FFFFFF',
    seashell: '#FFF5EB',
    antiquewhite: '#FFEAD8',
    bisque: '#FFE0C5',
    navajowhite: '#FFD6B1',
    navjowhite: '#FFCC9E'
};
const Classic_Red_White_Green_Light = {
    palegreen: '#B7E6A7',
    lightgrey: '#C6EBB8',
    gainsboro: '#D5F0CA',
    beige: '#E3F5DB',
    honeydew: '#F1FAED',
    white: '#FFFFFF',
    lavenderblush: '#FFF0F0',
    mistyrose: '#FFE0E1',
    pink: '#FFD1D3',
    pinker: '#FFC2C5',
    lightpink: '#FFB2B6'
};